import React, { useState } from 'react';
import { Download, Folder, AlertCircle, CheckCircle, X } from 'lucide-react';

const DownloadGalleryControls = ({ onDownloadImages }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadStatus, setDownloadStatus] = useState(null);

  const handleDownload = async () => {
    try {
      // Check if File System Access API is available
      if (!('showDirectoryPicker' in window)) {
        setDownloadStatus({
          type: 'error',
          message: 'Directory picker not supported. Use Chrome/Edge or download manually.'
        });
        return;
      }

      setIsDownloading(true);
      setDownloadProgress(0);
      setDownloadStatus(null);

      // Request directory from user
      const directoryHandle = await window.showDirectoryPicker({
        mode: 'readwrite',
        startIn: 'downloads'
      });

      // Start download process
      await onDownloadImages(directoryHandle, (progress) => {
        setDownloadProgress(progress);
      });

      setDownloadStatus({ type: 'success', message: 'All images downloaded successfully!' });
    } catch (error) {
      if (error.name === 'AbortError') {
        setDownloadStatus({ type: 'info', message: 'Download cancelled by user' });
      } else {
        console.error('Download failed:', error);
        setDownloadStatus({ type: 'error', message: `Download failed: ${error.message}` });
      }
    } finally {
      setIsDownloading(false);
    }
  };

  const clearStatus = () => {
    setDownloadStatus(null);
    setDownloadProgress(0);
  };

  return (
    <div className="dropdown-container">
      <button
        className="btn"
        onClick={handleDownload}
        disabled={isDownloading}
      >
        {isDownloading ? (
          <>
            <div className="spinner" style={{ width: 16, height: 16 }}></div>
            Downloading...
          </>
        ) : (
          <>
            <Download size={16} />
            Download all images
          </>
        )}
      </button>
      
      {isDownloading && (
        <div className="download-progress">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${downloadProgress}%` }}
            ></div>
          </div>
          <span>{Math.round(downloadProgress)}%</span>
        </div>
      )}
      
      {downloadStatus && (
        <div className={`download-status ${downloadStatus.type}`}>
          {downloadStatus.type === 'success' && <CheckCircle size={16} />}
          {downloadStatus.type === 'error' && <AlertCircle size={16} />}
          {downloadStatus.type === 'info' && <Folder size={16} />}
          <span>{downloadStatus.message}</span>
          <button className="close-btn" onClick={clearStatus}>
            <X size={14} />
          </button>
        </div>
      )}
    </div>
  );
};

export default DownloadGalleryControls;